import { action, thunk } from 'easy-peasy'

import { FetchStatus, Paginator } from '@types'

import { OutletModel, outletService } from '.'

export const outlet: OutletModel = {
  paginator: {} as Paginator,
  outlets: [],
  featuredOutlets: [],
  status: FetchStatus.LOADING,
  error: {},

  // Actions
  setPaginator: action((state, payload) => {
    state.paginator = payload
  }),
  setOutlets: action((state, payload) => {
    state.outlets = payload
  }),
  addOutlets: action((state, payload) => {
    state.outlets = [...state.outlets, ...payload]
  }),
  setFeaturedOutlets: action((state, payload) => {
    state.featuredOutlets = payload
  }),
  setStatus: action((state, payload) => {
    state.status = payload
  }),
  setError: action((state, payload) => {
    state.error = payload
  }),

  // Thunks
  fetchAllOutlet: thunk(async (action, payload) => {
    action.setStatus(FetchStatus.LOADING)
    try {
      const first = await outletService.getAllOutlet(payload)
      let allData = first.data
      const totalPages = first.paginator?.total_pages || 1
      const startPage = payload.page || 1
      if (totalPages > startPage) {
        const restPages = Array.from(
          { length: totalPages - startPage },
          (_, i) => startPage + i + 1
        )
        const rest = await Promise.all(
          restPages.map((page) =>
            outletService.getAllOutlet({ ...payload, page })
          )
        )
        rest.forEach((res) => {
          allData = allData.concat(res.data)
        })
      }
      action.setPaginator(first.paginator)
      action.setOutlets(allData)
      action.setStatus(FetchStatus.LOADED)
      action.setError({})
    } catch (e) {
      action.setError(e)
      action.setStatus(FetchStatus.ERROR)
    }
  }),

  fetchFeaturedOutlet: thunk((action, payload) => {
    outletService
      .getAllOutlet({ ...payload, featured: 1 })
      .then(({ data }) => {
        action.setFeaturedOutlets(data)
      })
      .catch(() => {
        action.setFeaturedOutlets([])
      })
  }),

  fetchMoreOutlet: thunk((action, payload) => {
    action.setStatus(FetchStatus.FETCHING_MORE)
    outletService
      .getAllOutlet(payload)
      .then(({ data, paginator }) => {
        action.setPaginator(paginator)
        action.addOutlets(data)
        action.setStatus(FetchStatus.LOADED)
        action.setError({})
      })
      .catch(() => {
        action.setStatus(FetchStatus.FETCHING_MORE_ERROR)
        action.setStatus(FetchStatus.LOADED)
      })
  })
}
